module.exports = __webpack_public_path__ + "img/mouth1.8157da5a.png";